const system = `<?xml version="1.0" encoding="UTF-8"?>
<pnml>
<net type="http://www.pnml.org/version-2009/grammar/pnmlcoremodel" id="Generated by Petri Net Editor">
    <name>
        <text>Generated by Petri Net Editor</text>
    </name>
    <page id="page-1">
       <place id="place-1">
            <name>
                <text>place-1</text>
            </name>
            <graphics>
                <position x="-9" y="-75"/>
            </graphics>
            <toolspecific tool="ProM" version="6.4" localNodeID="c5110944-0c3e-4d34-9a58-594234a39d04" />
       </place>
       <place id="place-2">
            <name>
                <text>place-2</text>
            </name>
            <graphics>
                <position x="222" y="-74"/>
            </graphics>
            <toolspecific tool="ProM" version="6.4" localNodeID="e6019761-d099-44b9-82f9-9d9ff276267b" />
       </place>
       <place id="place-3">
            <name>
                <text>place-3</text>
            </name>
            <graphics>
                <position x="221" y="100"/>
            </graphics>
            <toolspecific tool="ProM" version="6.4" localNodeID="fca9446f-dd25-4606-b1a0-d9f745ded21b" />
       </place>
       <place id="place-4">
            <name>
                <text>place-4</text>
            </name>
            <graphics>
                <position x="455" y="-74"/>
            </graphics>
            <toolspecific tool="ProM" version="6.4" localNodeID="eba459f1-02e1-420b-86c7-e97e7e663456" />
       </place>
       <place id="place-5">
            <name>
                <text>place-5</text>
            </name>
            <graphics>
                <position x="455" y="100"/>
            </graphics>
            <toolspecific tool="ProM" version="6.4" localNodeID="c75fcd11-30a7-48fd-84ca-562f9fad859e" />
       </place>
       <place id="place-6">
            <name>
                <text>place-6</text>
            </name>
            <graphics>
                <position x="647" y="14"/>
            </graphics>
            <toolspecific tool="ProM" version="6.4" localNodeID="faa61271-aad1-4ad3-b07a-076412abc8d1" />
       </place>
       <transition id="transition-1" invisible="true">
            <name>
                <text>action</text>
            </name>
            <graphics>
                <position x="103" y="-79"/>
            </graphics>
            <toolspecific tool="ProM" version="6.4" localNodeID="16e41e1c-88c0-4689-9ae8-4ea3f3c83960" activity="$invisible$"/>
       </transition>
       <transition id="transition-2" invisible="false">
            <name>
                <text>a</text>
            </name>
            <graphics>
                <position x="329" y="-80"/>
            </graphics>
            <toolspecific tool="ProM" version="6.4" localNodeID="cc453140-89a3-4b96-8363-1c90ef4cc2de" activity=""/>
       </transition>
       <transition id="transition-3" invisible="false">
            <name>
                <text>b</text>
            </name>
            <graphics>
                <position x="329" y="9"/>
            </graphics>
            <toolspecific tool="ProM" version="6.4" localNodeID="6842f382-41d3-4a25-99a8-9b34f428d12e" activity=""/>
       </transition>
       <transition id="transition-4" invisible="false">
            <name>
                <text>c</text>
            </name>
            <graphics>
                <position x="329" y="95"/>
            </graphics>
            <toolspecific tool="ProM" version="6.4" localNodeID="8d25f840-d6c9-44d5-b6b7-fa5f15ac8924" activity=""/>
       </transition>
       <transition id="transition-5" invisible="true">
            <name>
                <text>action</text>
            </name>
            <graphics>
                <position x="344" y="184"/>
            </graphics>
            <toolspecific tool="ProM" version="6.4" localNodeID="256a3b5b-f555-4e01-982f-fc681c7fdff7" activity="$invisible$"/>
       </transition>
       <transition id="transition-6" invisible="true">
            <name>
                <text>action</text>
            </name>
            <graphics>
                <position x="554" y="9"/>
            </graphics>
            <toolspecific tool="ProM" version="6.4" localNodeID="343c7a38-18e1-4aa7-94e3-7052fd3f8642" activity="$invisible$"/>
       </transition>
       <arc id="flow-12" source="place-1" target="transition-1">
            <toolspecific tool="ProM" version="6.4" localNodeID="96347a09-fde3-4688-b57a-43e0a633c653" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="40" y="-50"/>
                <position x="103" y="-50"/>
           </graphics>       
        </arc>
       <arc id="flow-14" source="transition-1" target="place-3">
            <toolspecific tool="ProM" version="6.4" localNodeID="85265561-da5e-476d-81ae-415bceb38c06" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="118" y="-19"/>
                <position x="118" y="124"/>
                <position x="221" y="124"/>
           </graphics>       
        </arc>
       <arc id="flow-16" source="transition-1" target="place-2">
            <toolspecific tool="ProM" version="6.4" localNodeID="e757674a-9be4-4493-ba33-2791a6e643da" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="133" y="-49"/>
                <position x="222" y="-49"/>
           </graphics>       
        </arc>
       <arc id="flow-17" source="place-2" target="transition-2">
            <toolspecific tool="ProM" version="6.4" localNodeID="0d282f4d-bcc1-42a7-b587-cd28cbd489af" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="272" y="-50"/>
                <position x="329" y="-50"/>
           </graphics>       
        </arc>
       <arc id="flow-19" source="transition-3" target="place-4">
            <toolspecific tool="ProM" version="6.4" localNodeID="c4b20458-a91d-4d8a-b336-c1a4d276b3c0" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="389" y="39"/>
                <position x="479" y="39"/>
                <position x="479" y="-24"/>
           </graphics>       
        </arc>
       <arc id="flow-21" source="transition-2" target="place-4">
            <toolspecific tool="ProM" version="6.4" localNodeID="e2a74903-ab8b-43e3-88d7-f878d6280ed5" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="389" y="-50"/>
                <position x="455" y="-50"/>
           </graphics>       
        </arc>
       <arc id="flow-22" source="place-3" target="transition-4">
            <toolspecific tool="ProM" version="6.4" localNodeID="76289e8a-9185-4c1e-b115-edc52536e0db" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="271" y="125"/>
                <position x="329" y="125"/>
           </graphics>       
        </arc>
       <arc id="flow-23" source="transition-4" target="place-5">
            <toolspecific tool="ProM" version="6.4" localNodeID="59c043a5-5f3d-4818-8c0e-62d4a59c8e08" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="389" y="125"/>
                <position x="455" y="125"/>
           </graphics>       
        </arc>
       <arc id="flow-24" source="place-5" target="transition-5">
            <toolspecific tool="ProM" version="6.4" localNodeID="5d01cee2-cbee-4d41-8702-5d84ef2ce0c2" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="480" y="150"/>
                <position x="480" y="214"/>
                <position x="374" y="214"/>
           </graphics>       
        </arc>
       <arc id="flow-26" source="transition-5" target="place-3">
            <toolspecific tool="ProM" version="6.4" localNodeID="dd144555-1505-4c1f-aee0-a25d9c324213" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="344" y="214"/>
                <position x="247" y="214"/>
                <position x="246" y="150"/>
           </graphics>       
        </arc>
       <arc id="flow-27" source="place-5" target="transition-6">
            <toolspecific tool="ProM" version="6.4" localNodeID="8ce721d8-c3bf-48bf-be9a-38e55659ebdd" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="505" y="125"/>
                <position x="569" y="126"/>
                <position x="569" y="69"/>
           </graphics>       
        </arc>
       <arc id="flow-29" source="place-4" target="transition-6">
            <toolspecific tool="ProM" version="6.4" localNodeID="bed604c4-46d1-4034-89d8-6a22ffe94788" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="505" y="-50"/>
                <position x="569" y="-52"/>
                <position x="569" y="9"/>
           </graphics>       
        </arc>
       <arc id="flow-30" source="transition-6" target="place-6">
            <toolspecific tool="ProM" version="6.4" localNodeID="b7006ee3-f605-468b-9477-5a09575cdb52" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="584" y="39"/>
                <position x="647" y="39"/>
           </graphics>       
        </arc>
       <arc id="flow-1" source="place-3" target="transition-3">
            <toolspecific tool="ProM" version="6.4" localNodeID="5d5af9de-769c-4418-986c-27ce72bf0726" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="246" y="100"/>
                <position x="246" y="50"/>
                <position x="329" y="50"/>
           </graphics>       
        </arc>
       <arc id="flow-4" source="place-2" target="transition-3">
            <toolspecific tool="ProM" version="6.4" localNodeID="8713f9fc-10c9-406a-8852-c209590d5fed" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="243" y="-24"/>
                <position x="243" y="33"/>
                <position x="329" y="33"/>
           </graphics>       
        </arc>
       <arc id="flow-8" source="transition-3" target="place-5">
            <toolspecific tool="ProM" version="6.4" localNodeID="6b28f711-3663-4ce5-8d00-5f152dc0150b" />
            <arctype>
                <text>normal</text>
            </arctype>
            <graphics>            
                <position x="359" y="56"/>
                <position x="479" y="56"/>
                <position x="479" y="100"/>
           </graphics>       
        </arc>
   </page>
</net>
</pnml>
`

export default system;